import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideSignalFormsConfig } from '@angular/forms/signals';
import { NG_STATUS_CLASSES } from '@angular/forms/signals/compat';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, TitleStrategy, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideSdsIcons } from '@nieuwestroom/sds-icon';
import { icons } from '@nieuwestroom/sds-icon-pack';

import { apiAuthorizationToken, apiHalTransform, apiHealthCheck } from '@customer-portal/api';
import { provideAuthentication } from '@customer-portal/ciam';
import { TranslocoTitleStrategy } from '@customer-portal/navigation/breadcrumb';
import { provideAppSettings, provideBuildInfo, serverErrorHandling, serverErrorNormalizer } from '@customer-portal/utils';

import { BUILD_INFO } from '../build-info';
import { environment } from '../environments/environment';
import { provideAnalyticsConfig } from './app.config-analytics';
import { provideApiService } from './app.config-api-service';
import { provideApiToken } from './app.config-api-token';
import { provideCustomerChat } from './app.config-customer-chat';
import { provideCustomerSupport } from './app.config-customer-support';
import { provideFeatureFlags } from './app.config-feature-flags';
import { providePrimitives } from './app.config-primitives';
import { provideSentry } from './app.config-sentry';
import { provideStatistics } from './app.config-statistics';
import { provideTranslation } from './app.config-translate';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    ...provideSentry(),
    provideAppSettings(environment),
    provideBuildInfo(BUILD_INFO),
    ...provideAuthentication(environment.keycloakConfig),
    provideApiToken(),
    provideZonelessChangeDetection(),
    provideRouter(appRoutes, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    { provide: TitleStrategy, useClass: TranslocoTitleStrategy },
    provideHttpClient(withInterceptors([apiAuthorizationToken, apiHealthCheck, serverErrorHandling, serverErrorNormalizer, apiHalTransform])),
    provideSignalFormsConfig({
      classes: NG_STATUS_CLASSES,
    }),
    ...provideTranslation(),
    ...provideFeatureFlags(),
    ...provideApiService(),
    ...provideCustomerChat(),
    ...providePrimitives(),
    ...provideCustomerSupport(),
    ...provideStatistics(),
    provideAnimations(),
    ...provideSdsIcons(icons),
    ...provideAnalyticsConfig(),
  ],
};
